var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.479,
    height: 18.48,
    viewBox: "0 0 18.479 18.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.222,19.778a5.006,5.006,0,0,0,7.071,0l2.828-2.829-1.414-1.414L9.879,18.364a3,3,0,1,1-4.243-4.243l2.829-2.828L7.051,9.879,4.222,12.707A5.006,5.006,0,0,0,4.222,19.778Zm15.556-8.485a5,5,0,1,0-7.071-7.071L9.879,7.051l1.414,1.414,2.828-2.829a3,3,0,0,1,4.243,4.243l-2.829,2.828,1.414,1.414Z",
    transform: "translate(-2.76 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,6h2V18H11Z",
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 9.24, 26.21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLink);
export default __webpack_public_path__ + "static/media/ico-link.61057cb9.svg";
export { ForwardRef as ReactComponent };